import * as React from 'react';
import { Modal as BootstrapModal } from 'react-bootstrap';
import axios from 'axios';
import { IQuoteActions } from '../../../../services/quote/models';

const ModalHeader = BootstrapModal.Header;
const ModalTitle = BootstrapModal.Title;
const ModalBody = BootstrapModal.Body;

interface IPaymentModalProps {
    transactionId: string;
    paymentUrl: string;
    actions: { quote: IQuoteActions; push: (route: string) => void; };
    showModal: boolean;
    onClose: () => void;
}

class PaymentModal extends React.Component<IPaymentModalProps> {
    public componentDidMount() {
        if (process.env.BROWSER) { window.addEventListener('message', this.handleWindowMessage); }
    }
    public componentWillUnmount() {
        if (process.env.BROWSER) { window.removeEventListener('message', this.handleWindowMessage); }
    }

    private closeModal = () => this.props.onClose();

    private handleWindowMessage = (event) => {
        const { actions } = this.props;
        const origin =
            event.origin ||
            (event.originalEvent && event.originalEvent.origin);
        if (origin !== axios.defaults.baseURL) { return; }

        const data = event.data;
        window.scrollTo(0, 0);

        if (data.status !== 'complete') {
            actions.quote.error('Payment Error: ' + data.message);
            this.closeModal();
            return;
        }

        actions.quote.complete(data.policies[0]);
        this.closeModal();
        actions.quote.addStepToWizard('complete', false);
        actions.push('/complete');
    }

    public render() {
        if (!this.props.showModal) { return null; }

        return (
            <BootstrapModal
                show={true}
                onHide={this.closeModal}
                bsSize="large"
                keyboard={false}
                backdrop="static"
                className="payments-modal"
            >
                <ModalHeader>
                    <ModalTitle>Payment</ModalTitle>
                </ModalHeader>
                <ModalBody>
                    <iframe src={this.props.paymentUrl} />
                </ModalBody>
            </BootstrapModal>
        );
    }
}

export default PaymentModal;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/components/PaymentModal/index.tsx